export default __webpack_public_path__ + "static/media/4.d289a1a8.png";